import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";
import { Link } from "react-router-dom";
import logo from "../../assets/image/admin-logo.png";

const LogoWrapper = styled(Link)({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	textDecoration: "none",
	width: "100%",
	padding: 0,
	margin: 0,
	transition: "opacity 0.2s ease, transform 0.2s ease",
	"&:hover": {
		opacity: 0.92,
	},
});

const LogoImg = styled("img")({
	width: "71%",
	maxWidth: "100%",
	height: "auto",
	objectFit: "contain",
	display: "block",
});

const TooltipWrapper = styled(({ className, ...props }: TooltipProps) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: "#0F172A",
		color: "#FFFFFF",
		fontSize: "0.75rem",
		fontWeight: 600,
		borderRadius: "6px",
		boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
	},
	[`& .${tooltipClasses.arrow}`]: {
		color: "#0F172A",
	},
}));

function Logo() {
	return (
		<LogoWrapper to="/dashboard">
			<LogoImg src={logo} alt="TOAB BTTF Admin Logo" />
		</LogoWrapper>
	);
}

export default Logo;
